{
  "deep_search.advanced_no_suggestions": "Aucune suggestion",
  "deep_search.advanced_no_suggestions_hint": "Saisissez un champ ou choisissez un exemple",
  "deep_search.advanced_placeholder": "Rechercher des documents… ex. Name:invoice Tag:invoice FileSize:>1000",
  "deep_search.attr.doc.Currency": "Monnaie",
  "deep_search.attr.doc.CustomerCity": "Lieu client",
  "deep_search.attr.doc.CustomerCountry": "Pays client",
  "deep_search.attr.doc.CustomerName": "Nom du client",
  "deep_search.attr.doc.CustomerZip": "NPA client",
  "deep_search.attr.doc.DocumentLanguage": "Langue",
  "deep_search.attr.doc.DocumentTitle": "Titre du document",
  "deep_search.attr.doc.DocumentType": "Type de document",
  "deep_search.attr.doc.DueDate": "Date d'échéance",
  "deep_search.attr.doc.InvoiceDate": "Date du document",
  "deep_search.attr.doc.InvoiceNumber": "Numéro du document",
  "deep_search.attr.doc.InvoicePeriodFrom": "Période de",
  "deep_search.attr.doc.InvoicePeriodTo": "Période à",
  "deep_search.attr.doc.PurchaseOrderNumber": "Numéro de commande",
  "deep_search.attr.doc.TotalInclVat": "Total TVA incl.",
  "deep_search.attr.doc.VendorCity": "Lieu fournisseur",
  "deep_search.attr.doc.VendorCountry": "Pays fournisseur",
  "deep_search.attr.doc.VendorName": "Nom du fournisseur",
  "deep_search.attr.doc.VendorZip": "NPA fournisseur",
  "deep_search.attr.Assignee": "Assigné",
  "deep_search.boolean_and_subtitle": "Require both sides",
  "deep_search.boolean_close_group": "Close group",
  "deep_search.boolean_negate": "Negate next qualifier or term",
  "deep_search.boolean_not_subtitle": "Exclude following term",
  "deep_search.boolean_open_group": "Open group",
  "deep_search.boolean_or_subtitle": "Match either side",
  "deep_search.common_apply": "Appliquer",
  "deep_search.common_back": "Retour",
  "deep_search.common_save": "Enregistrer",
  "deep_search.date_picker_bare_date_hint": "Bare dates match the whole day in the active timezone (default Europe/Zurich).",
  "deep_search.date_picker_include_time": "Inclure l’heure",
  "deep_search.date_picker_utc": "UTC",
  "deep_search.date_picker_utc_date_only_hint": "Calendar date (UTC). Matches the whole UTC day; unaffected by tz:.",
  "deep_search.detail_clear": "Effacer",
  "deep_search.error.DANGLING_OPERATOR": "Opérateur incomplet dans la requête ({operator})",
  "deep_search.error.DUPLICATE_SORT_KEY": "Champ de tri en double : {key}",
  "deep_search.error.EMPTY_VALUE": "sort: nécessite au moins un champ",
  "deep_search.error.INVALID_ATTRIBUTE_KEY": "Impossible de trier par cet attribut : {key}",
  "deep_search.error.INVALID_TIMEZONE": "Fuseau horaire inconnu : {zone}",
  "deep_search.error.INVALID_VALUE_FORMAT": "Utilisez une date calendaire complète (YYYY-MM-DD)",
  "deep_search.error.INVALID_WILDCARD": "Les jokers en début de terme ne sont pas pris en charge",
  "deep_search.error.MISPLACED_DIRECTIVE": "sort: et tz: doivent figurer à la fin de la requête",
  "deep_search.error.QUERY_TOO_COMPLEX": "Cette requête est trop complexe",
  "deep_search.error.UNBALANCED_BRACES": "Parenthèses non équilibrées dans la requête",
  "deep_search.error.VALIDATION_ERROR": "Requête de recherche invalide",
  "deep_search.field.CreatedTime": "Créé",
  "deep_search.field.CreatedUser": "Créé par",
  "deep_search.field.FileSize": "Taille du fichier",
  "deep_search.field.Kind": "Genre",
  "deep_search.field.ModifiedTime": "Modifié",
  "deep_search.field.ModifiedUser": "Modifié par",
  "deep_search.field.Name": "Nom",
  "deep_search.field.OwnerUser": "Propriétaire",
  "deep_search.field.Tag": "Tag",
  "deep_search.field.Type": "Type",
  "deep_search.filters_all": "Tous",
  "deep_search.filters_clear_selected": "Effacer la sélection",
  "deep_search.filters_select_all": "Sélectionner tous les filtres",
  "deep_search.filters_contains_placeholder": "Contient le texte",
  "deep_search.filters_enter_value": "Saisir {label}…",
  "deep_search.filters_find_criteria": "Trouver un critère…",
  "deep_search.filters_find_sort": "Trouver un tri…",
  "deep_search.filters_find_value": "Trouver {label}…",
  "deep_search.filters_loading_options": "Chargement des options…",
  "deep_search.filters_mode_date": "Date / plage",
  "deep_search.filters_mode_number": "Nombre / plage",
  "deep_search.filters_mode_options": "Choisir une valeur",
  "deep_search.filters_mode_text": "Texte",
  "deep_search.filters_more": "Plus",
  "deep_search.filters_others": "(+ {count} autres)",
  "deep_search.filters_no_matching_criteria": "Aucun critère correspondant",
  "deep_search.filters_number_range": "Plage numérique…",
  "deep_search.filters_pick_date": "Choisir une date…",
  "deep_search.filters_pick_date_range": "Choisir une plage de dates…",
  "deep_search.filters_sort_label": "Tri :",
  "deep_search.filters_sort_relevance": "Pertinence (défaut)",
  "deep_search.filters_use_value": "Utiliser « {value} »",
  "deep_search.menu_all": "Tous",
  "deep_search.menu_find": "Rechercher…",
  "deep_search.menu_no_matching": "Aucune option correspondante",
  "deep_search.number_range_from": "De",
  "deep_search.number_range_preset_0_up": "0 et plus",
  "deep_search.number_range_preset_100_500": "100 – 500",
  "deep_search.number_range_preset_1k_5k": "1,000 – 5 000",
  "deep_search.number_range_preset_up_to_1k": "Jusqu'à 1 000",
  "deep_search.number_range_presets": "Préréglages",
  "deep_search.number_range_to": "À",
  "deep_search.options_load_failed": "Impossible de charger les options de filtre",
  "deep_search.relative_14d": "il y a 14 jours",
  "deep_search.relative_1h": "il y a 1 heure",
  "deep_search.relative_24h": "il y a 24 heures",
  "deep_search.relative_30d": "il y a 30 jours",
  "deep_search.relative_7d": "il y a 7 jours",
  "deep_search.save_dialog_cancel": "Annuler",
  "deep_search.save_dialog_confirm": "Enregistrer",
  "deep_search.save_dialog_confirm_create": "Enregistrer la recherche",
  "deep_search.save_dialog_edit_subtitle": "Modifiez le nom ou la vue associée. La requête est affichée pour référence.",
  "deep_search.save_dialog_edit_title": "Modifier la recherche",
  "deep_search.save_dialog_name": "Nom de la recherche",
  "deep_search.save_dialog_name_required": "Saisir un nom",
  "deep_search.save_dialog_query": "Requête",
  "deep_search.save_dialog_subtitle": "Enregistrez la recherche actuelle pour y accéder rapidement plus tard.",
  "deep_search.save_dialog_table_options": "Colonnes personnalisées",
  "deep_search.save_dialog_table_options_hint": "Cette sélection de colonnes est enregistrée avec la recherche. Supprimez-la pour utiliser les colonnes de la vue à la place.",
  "deep_search.save_dialog_title": "Enregistrer la recherche",
  "deep_search.save_dialog_variant": "Mode de recherche",
  "deep_search.save_dialog_view": "Vue",
  "deep_search.save_dialog_view_hint": "Supprimez pour appliquer cette recherche dans la vue actuellement ouverte.",
  "deep_search.sort_created_newest": "Créé (plus récent)",
  "deep_search.sort_file_size_largest": "Taille (plus grande)",
  "deep_search.sort_modified_newest": "Modifié (plus récent)",
  "deep_search.sort_modified_oldest": "Modifié (plus ancien)",
  "deep_search.sort_name_az": "Nom (A–Z)",
  "deep_search.sort_relevance": "Pertinence",
  "deep_search.suggestion_absolute_date": "Date absolue",
  "deep_search.suggestion_date_range": "Plage de dates",
  "deep_search.suggestion_number_range": "Plage numérique",
  "deep_search.variant_advanced": "Avancé",
  "deep_search.variant_incompatible_boolean": "Cette requête utilise des opérateurs booléens — passez en Advanced",
  "deep_search.variant_incompatible_complex": "Cette requête est trop complexe pour Simple — passez en Advanced",
  "deep_search.variant_incompatible_grouping": "Cette requête utilise des groupes / une imbrication — passez en Advanced",
  "deep_search.variant_simple": "Simple",
  "deep_search.location_everywhere": "Partout dans {location}",
  "deep_search.location_current": "Actuel : {location}",
  "deep_search.location_more": "Plus d'emplacements…",
  "deep_search.location_select_title": "Choisir un emplacement",
  "deep_search.location_clear": "Rechercher dans toute la box",
  "deep_search.location_reset_default": "Réinitialiser l'emplacement par défaut",
  "deep_search.table_header_location": "Emplacement",
  "deep_search.search_in_location": "Rechercher dans « {location} »…",
  "deep_search.quick_show_all": "Afficher tous les résultats",
  "deep_search.quick_no_results": "Aucun résultat",
  "deep_search.quick_modified_by": "Modifié par {user} · {when}"
}
